import Column from '@components/column'
import Typography from '@components/typography'
import { FC, Fragment } from 'react'
import Empty from '@commons/empty'
import {
  StyleError,
  StyleImageWrapper,
  StyleSelectedWrapper,
  StyleTag,
} from './style'
import Row from '@components/row'
import Svg from '@components/svg'
import Circle from '@components/circle'
interface SelectedLabTestsProps {
  selectedItems: any[]
  setFieldValue: (field: string, value: any, shouldValidate?: boolean) => void
  name: string
  multiple?: boolean
  error?: any
}
const SelectedLabTests: FC<SelectedLabTestsProps> = ({
  selectedItems,
  setFieldValue,
  name,
  multiple = false,
  error,
}) => {
  const handleClickRemove = (event) => {
    const target = event.target as HTMLElement
    const cross = target.closest('[data-cross-id]')
    if (!!cross) {
      if (!multiple) {
        setFieldValue(name, [])
      }
      if (!!multiple) {
        const id: any = cross.getAttribute('data-cross-id')
        if (!!id) {
          const filterItems = selectedItems?.filter(
            (item: any) => item?.id != id,
          )
          setFieldValue(name, filterItems)
        }
      }
    }
  }
  return (
    <Column rowGap={20}>
      <Typography content="Lab Tests" size={16} tc="primary" />
      {!!selectedItems?.length ? (
        <Column onClick={handleClickRemove} rowGap={15}>
          {selectedItems?.map((selectedItem: any) => {
            return (
              <Fragment key={selectedItem?.id}>
                <StyleSelectedWrapper>
                  <Row styleRow="width:100%;" colGap={10} alignItems="center">
                    <StyleImageWrapper>
                      <Svg svg="labtest" />
                    </StyleImageWrapper>
                    <Row alignItems="center" justifyContent="space-between">
                      <Column rowGap={10}>
                        <Typography
                          content={selectedItem?.name}
                          tc="text"
                          size={14}
                        />
                        <Row colGap={5}>
                          <StyleTag>
                            <Svg svg="plusHeart" size={16} />
                            <Typography
                              content={selectedItem?.category?.name}
                              size={12}
                              tc="text"
                            />
                          </StyleTag>
                          {selectedItem?.sampleTypes?.map((sampleType: any) => {
                            return (
                              <Fragment key={sampleType?.id}>
                                <StyleTag>
                                  <Typography
                                    content={sampleType?.name}
                                    size={12}
                                    tc="text"
                                  />
                                </StyleTag>
                              </Fragment>
                            )
                          })}
                        </Row>
                      </Column>
                    </Row>
                    <Circle
                      size={20}
                      styleCircle="margin-left:auto;"
                      bg="primary600"
                      data-cross-id={selectedItem.id}
                    >
                      <Svg svg="cross" size={14} />
                    </Circle>
                  </Row>
                </StyleSelectedWrapper>
              </Fragment>
            )
          })}
        </Column>
      ) : (
        <Empty />
      )}
      {!!error && <StyleError>{error}</StyleError>}
    </Column>
  )
}

export default SelectedLabTests
